// src/utils/api.js
import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
});

export const obtenerGrupos = async (token) => {
	try {
		const respuesta = await api.get("/api/v1/automatic-planning-groups", {
			headers: { Authorization: `Bearer ${token}` },
		});
		return respuesta.data;
	} catch (error) {
		throw error;
	}
};

/**
 * POST /api/v1/workflows
 * @param {{ start_date: string, end_date: string, groups: string[] }} params
 * @param {string} token
 */
export const ejecutar = async ({ start_date, end_date, automatic_planning_groups }, token) => {
	try {
		const respuesta = await api.post(
			"/api/v1/workflows",
			{ start_date, end_date, automatic_planning_groups },
			{ headers: { Authorization: `Bearer ${token}` } }
		);

		// …
		return respuesta.data.workflow_execution_id;
	} catch (error) {
		throw error;
	}
};

/**
 * GET /api/v1/workflows/{executionId}
 * @param {string} executionId
 * @param {string} token
 */
export const obtenerEstado = async (executionId, token) => {
	try {
		const respuesta = await api.get(`/api/v1/workflows/${executionId}`, {
			headers: { Authorization: `Bearer ${token}` },
		});

		return respuesta.data.status;
	} catch (error) {
		throw error;
	}
};

/**
 * GET /api/v1/reports/{executionId}
 * @param {string} executionId
 * @param {string} token
 */
export const obtenerInfoFinal = async (executionId, token) => {
	try {
		const respuesta = await api.get(`/api/v1/reports/${executionId}`, {
			headers: { Authorization: `Bearer ${token}` },
		});
		return respuesta.data;
	} catch (error) {
		throw error;
	}
};
